import { ProfileCustomValuesList } from "PFApp/components/custom_values_list";
import { getRelatedSkills } from "PFApp/hooks/matches";
import { useMatchProfileInfo } from "PFApp/hooks/use_match_profile_info";
import { Divider } from "PFComponents/divider";
import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

import { InfoSection } from "../../components/info_section";
import { useMatchCardContext } from "../../match_card_context";
import { ActivityMatchCustomFields } from "../match_activity_custom_fields";
import { MatchActivitySkills } from "../match_activity_skills";
import css from "./match_card_body.module.scss";
import { ShortlistStateSection } from "./parts/shortlist_state_section";

export const MatchCardBody = () => {
  const {
    isCompressed,
    customValues,
    id: profileId,
    profile,
    animate,
    isUnbiasedMode
  } = useMatchCardContext();
  const { sideInfo } = useMatchProfileInfo(profile);
  const { t } = useTranslation("activities", { keyPrefix: "show.matches.card" });

  const { matchSkills: relatedSkills } = getRelatedSkills(customValues);

  const showShortlistStateSectionDivider = isCompressed || relatedSkills.length > 0;

  return (
    <div className={css.cardBodyContainer}>
      <Divider />
      <div className={css.cardBody}>
        <div className={css.sideArea}>
          <ActivityMatchCustomFields />
          {sideInfo.map(({ customType, value }) => (
            <InfoSection title={customType.display_as || customType.name} key={customType.id}>
              <Typography withMargin variant="labelBold">
                {value}
              </Typography>
            </InfoSection>
          ))}
        </div>
        <Divider type="vertical" />
        <div className={css.mainArea}>
          {isCompressed && <MatchActivitySkills />}
          {relatedSkills.length > 0 && (
            <InfoSection title={t("relatedSkills")} tooltipContent={t("relatedSkillsTooltip")}>
              <ProfileCustomValuesList
                customFieldName="skills"
                customValues={relatedSkills}
                profileId={profileId}
                onMoreLessButtonClick={animate}
                isUnbiasedMode={isUnbiasedMode}
              />
            </InfoSection>
          )}
          <ShortlistStateSection showDivider={showShortlistStateSectionDivider} />
        </div>
      </div>
    </div>
  );
};
